import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';

const Card = ({ title, value, color, icon: Icon }) => {
    useEffect(() => {
        AOS.init({
            duration: 800,
            once: true,
        });
    }, []);

    return (
        <div
            data-aos="fade-up"
            data-aos-delay="100"
            className="bg-white/30 backdrop-blur-md border border-gray-200 shadow-xl rounded-2xl p-6 transition-all duration-300 transform hover:-translate-y-1 hover:shadow-2xl group relative overflow-hidden"
        >
            {/* Decorative Gradient Glow Border */}
            <div className="absolute inset-0 rounded-2xl border-2 border-transparent group-hover:border-gradient-to-r from-blue-400 to-purple-500 transition-all duration-500 pointer-events-none" />

            {/* Content */}
            <div className="flex items-center space-x-3 mb-4">
                <div className="p-3 bg-white rounded-full shadow-sm transition-transform duration-300 group-hover:scale-110">
                    <Icon className="h-6 w-6 text-blue-500" />
                </div>
                <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
            </div>
            <p className={`text-4xl font-bold ${color}`}>{value}</p>
        </div>
    );
};

export default Card;
